import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { UserSettings, UserSwitch } from '@clds/icon';
import { terminateAdminSession } from '@cld/session-service';
import { DropdownMenuItemWithLink } from '../../components/DropdownMenuItem';
import { DEMO_PAGE_URL, ADMIN_CONSOLE_URL } from '../../ApplicationWrapper.const';
import { useUserData, useCustomerIdContext } from '../../context';
import { messages } from '../../i18n';

export const UserAdminItems = () => {
  const { formatMessage } = useIntl();
  const { userData: user } = useUserData();
  const { currentCustomer } = useCustomerIdContext();

  const isMyAccount = user?.userInfo?.accountId === currentCustomer?.accountId;
  const onSwitchAccountClick = useCallback(() => {
    if (isMyAccount) {
      window.location.assign(DEMO_PAGE_URL);
    } else {
      terminateAdminSession();
    }
  }, [isMyAccount]);

  return (
    <>
      <DropdownMenuItemWithLink
        data-test-specifier="switch to demo account"
        analyticsMessage={isMyAccount ? 'switch to demo account' : 'switch to my account'}
        onClick={onSwitchAccountClick}
        leftSlot={<UserSwitch />}
      >
        {formatMessage(isMyAccount ? messages.userSwitchDemoAccount : messages.userSwitchMyAccount)}
      </DropdownMenuItemWithLink>
      <DropdownMenuItemWithLink
        data-test-specifier="manage account"
        analyticsMessage="manage account"
        href={`${ADMIN_CONSOLE_URL}/accounts${currentCustomer?.cloudName ? `?query=cn:${currentCustomer.cloudName}` : ''}`}
        leftSlot={<UserSettings />}
      >
        Manage account
      </DropdownMenuItemWithLink>
    </>
  );
};
